"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _qs = _interopRequireDefault(require("qs"));

var _common = require("@insided/deprecated-control/Event/create-event/common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'event-types';
exports.cssAnchorName = cssAnchorName;

var EventTypes = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventTypes, _Component);

  var _super = _createSuper(EventTypes);

  function EventTypes(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventTypes);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", function () {
      var _queryParameters$type;

      var searchQuery = typeof window !== 'undefined' ? window.location.search : '';

      var queryParameters = _qs.default.parse(searchQuery, {
        ignoreQueryPrefix: true
      });

      return {
        selectedEventType: (_queryParameters$type = queryParameters.type) !== null && _queryParameters$type !== void 0 ? _queryParameters$type : null
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setQueryParams", function (newEventType) {
      var searchQuery = window.location.search;

      var queryParameters = _qs.default.parse(searchQuery, {
        ignoreQueryPrefix: true
      });

      queryParameters === null || queryParameters === void 0 ? true : delete queryParameters.type;
      var newQuery = newEventType === null ? {
        type: queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.type
      } : {
        type: newEventType
      };

      var combinedQuery = _objectSpread(_objectSpread({}, queryParameters), newQuery); // @ts-expect-error


      combinedQuery === null || combinedQuery === void 0 ? true : delete combinedQuery.page;
      window.history.pushState('', '', "?".concat(_qs.default.stringify(combinedQuery)));
    });
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(EventTypes, [{
    key: "ListItem",
    value: function ListItem(name) {
      var _this2 = this;

      return (0, _preact.h)("li", {
        className: (0, _classnames.default)('event-types-list-item', {
          selected: this.state.selectedEventType === name
        }),
        role: "listitem",
        tabIndex: 0
      }, (0, _preact.h)("button", {
        role: "button",
        className: "event-types-list-item__button",
        onClick: function onClick() {
          return _this2.handleSelect(name);
        },
        onKeyUp: function onKeyUp(e) {
          return e.code === 'Enter' ? function () {} : null;
        }
      }, name === null ? (0, _preact.h)(_phrase.default, {
        p: "all.types"
      }) : (0, _common.getUnescapedName)(name)));
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(name) {
      this.setState({
        selectedEventType: name
      });
      this.setQueryParams(name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var eventTypes = this.props.eventTypes;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters', 'is-hidden-M', 'event-types-list-container')
      }, (0, _preact.h)("h2", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "event.type"
      })), (0, _preact.h)("ul", {
        className: "ideation-filters__product-area event-types-list",
        role: "list"
      }, this.ListItem(null), eventTypes.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      }).map(function (_ref) {
        var name = _ref.name;
        return _this3.ListItem(name);
      }))));
    }
  }]);
  return EventTypes;
}(_preact.Component);

exports.default = EventTypes;